import { gql } from '@apollo/client'

export const AUDIENCE_EXCLUSIONS = gql`
    query AudienceExclusions($publisherId: ID!, $campaignId: ID!, $objective: String!) {
        audienceExclusions(publisher_id: $publisherId, campaign_id: $campaignId, objective: $objective) {
            available
            sources {
                kind
                label
                retention_days
                status
                approximate_count_lower
                message
            }
        }
    }
`
